import { Typography } from 'antd';
import type { HotkeyBinding } from './HotkeyContext';

/** Строка подсказки под горячие клавиши — тот же список `bindings`, что передан в
 *  `useHotkeyScope`, поэтому подсказка не может разойтись с реальным поведением. */
export function HotkeyHint({ bindings }: { bindings: HotkeyBinding[] }) {
  if (bindings.length === 0) return null;
  return (
    <Typography.Text style={{ fontSize: 12, color: '#8c8c8c', display: 'block' }}>
      {bindings.map((b) => `${b.combo} — ${b.description}`).join(' · ')}
    </Typography.Text>
  );
}
